import * as cf from './config';
import * as hp from './helpers';
import cw from './commonwords';
import cc from './countryCodes';

export { cf, hp, cw, cc };

// ─── Contacts / People feature ───────────────────────────────────────────────
export * from './contactConstants';
export * from './people';
export * from './peopleReducers';